import { COLORS } from '@btime/constants'
import React from 'react'
import moment from 'moment'

import { TableColumn } from '../../../../../../components/tables/Table'

const colorRule = value => {
  let color = COLORS.dark2
  if (moment().subtract(3, 'days').isBefore(moment(value))) {
    color = COLORS.green
  } else if (moment().subtract(5, 'days').isSameOrBefore(moment(value))) {
    color = COLORS.orange
  } else {
    color = COLORS.red
  }
  return color
}

export const genNonComplianceColoringRuleColumn = formatter => (value, disabled) => {
  const color = colorRule(value)

  return <TableColumn color={!!disabled ? COLORS.dark3 : color}>{formatter(value)}</TableColumn>
}
